export default __webpack_public_path__ + "static/DSC_0016-971f193e3f5a159e6b664df47177e405.jpg";